<template>
  <Wrapper
    v-show="
      !preview && renderTools && 
      slideContainerActive.id
    "
    :position="slideContainerActive.position"
    id="slide-container-active-frame"
    :isActiveWidget="!!widgetActive.id || (detectDevice == 'mobile' && !isEnableMobile)"
  >
    <Legend class="lbl-name" :class="{'disabled': widgetActive.id || (detectDevice == 'mobile' && !isEnableMobile), 'lbl-hover': widgetActive.id}" @click="widgetActive.id && goTo('container')">
      Container
    </Legend>
    <SlideContainerTool class="d-flex slide-container-tool" v-if="detectDevice == 'mobile' && !widgetActive.id" :class="{'disabled': !isEnableMobile}" >
      <SlideContainerAction @click.stop.prevent="moveSlideContainerUp"
        v-show="indexSlideContainer !== 0 && components[slidePageID].style.layout !== '01'"
        ><i class="fas fa-sort-up"></i
      ></SlideContainerAction>
      <SlideContainerAction @click.stop.prevent="moveSlideContainerDown"
        v-show="slidePageID && indexSlideContainer !== components[slidePageID].componentsID.length - 1  && components[slidePageID].style.layout !== '01'"
        ><i style="transform: translateY(-8px)" class="fas fa-sort-down"></i
      ></SlideContainerAction>
      <SlideContainerAction @click.stop.prevent="toggleEnableMobile">
        <span v-show="isEnableMobile"
          v-b-tooltip.hover
          title="Hidden on Mobile"
        >
          <i
            style="font-size: 14px; transform: translateY(-6px)"
            class="far fa-eye-slash"
          ></i
        ></span>
        <span v-show="!isEnableMobile"
          v-b-tooltip.hover
          title="Show Slide Container"
        >
          <i
            style="font-size: 14px; transform: translateY(-6px)"
            class="far fa-eye"
          ></i
        ></span>
      </SlideContainerAction>
    </SlideContainerTool>
    <RePadding v-if="!widgetActive.id && detectDevice == 'desktop'" :component_id="slideContainerActive.id" />
    <!-- <div @click.stop.self.prevent v-if="!widgetActive.id"></div> -->
  </Wrapper>
</template>

<script>
import RePadding from "./RePadding.vue";
import { mapGetters } from "vuex";
import { Wrapper, Legend, SlideContainerTool, SlideContainerAction } from "./SlideContainerActive.styled";

export default {
  components: {
    Wrapper,
    Legend,
    SlideContainerTool,
    SlideContainerAction,
    RePadding,
  },

  data() {
    return {
      resizePaddingActive: undefined, // pdb | pdt | pdr | pdl
      positionTool: "top",
      topElementPosition: 0,
    };
  },
  methods: {
    goTo(type) {
      switch (type) {
        case "container": {
          if (this.slideContainerActive.id && this.slideSectionActive.id) {
            this.$store.dispatch("designIframe/frame/setWidgetActive", {})
            this.$store.dispatch("designIframe/frame/setWidgetHover", {})
            this.$store.dispatch("designIframe/component/elActive", {
              elementID: ["component", this.slideContainerActive.id],
            });
            this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
              component_id: this.slideContainerActive.id,
            });
          }
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
          this.$store.dispatch("designIframe/frame/setSectionHover", {});
          
          this.$store.dispatch("designIframe/frame/setSectionActive", {});
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
            component_id: this.slideSectionActive.id,
            index: this.slideSectionActive.index,
          });
          break;
        }
        default:
          break;
      }
    },
    moveSlideContainerUp() {
      this.$store.dispatch("designIframe/component/moveCellUp", {
        id: this.slideContainerActive.id,
        parent_id: this.slidePageID,
      });

      this.$nextTick(() => {
        this.resetSlideContainerToolPosition();
      });
    },
    moveSlideContainerDown() {
      this.$store.dispatch("designIframe/component/moveCellDown", {
        id: this.slideContainerActive.id,
        parent_id: this.slidePageID,
      });
      this.$nextTick(() => {
        this.resetSlideContainerToolPosition();
      });
    },
    resetSlideContainerToolPosition() {  
      if (this.slideContainerActive.id && this.slideSectionActive.id) {
        this.$store.dispatch("designIframe/frame/setWidgetActive", {})
        this.$store.dispatch("designIframe/frame/setWidgetHover", {})
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.slideContainerActive.id],
        });
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {
          component_id: this.slideContainerActive.id,
        });
      }
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      
      this.$store.dispatch("designIframe/frame/setSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
        component_id: this.slideSectionActive.id,
        index: this.slideSectionActive.index,
      });
    },
    toggleEnableMobile() {
      this.component.properties.isEnableMobile =
        !this.component.properties.isEnableMobile;
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
  },
  watch: {
    scrollPosition() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.slideContainerActive.id,
        type: "SLIDE_CONTAINER",
        action: "ACTIVE",
      });
    },
    mode() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.slideContainerActive.id,
          type: "SLIDE_CONTAINER",
          action: "ACTIVE",
        });
      });
    },
    slideContainerActive: {
      deep: true,
      handler() {
        const element = document.getElementById("slide-container-active-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      widgetActive: "designIframe/frame/widgetActive",
      slideContainerActive: "designIframe/frame/slideContainerActive",
      slideSectionActive: "designIframe/frame/slideSectionActive",
      components: "designIframe/metadata/components",
      mode: "designIframe/mode",
      scrollPosition: "scrollPosition",
      detectDevice: "detectDevice",
    }),
    component() {
      return this.components[this.slideContainerActive.id] || {};
    },
    slidePageID() {
     return this.slideSectionActive.id && this.components[this.slideSectionActive.id].componentsID[[this.slideSectionActive.index]]
    },
    isEnableMobile() {
      if (!this.slideContainerActive.id) {
        return false;
      }
      return !(
        this.component.properties.isEnableMobile != undefined &&
        this.component.properties.isEnableMobile == false
      );
    },
    indexSlideContainer() {
      if (this.components[this.slidePageID]) {
        if (this.detectDevice == 'mobile') {
          return this.components[this.slidePageID].componentsIDMobile.indexOf(this.slideContainerActive.id);
        } else {
          return this.components[this.slidePageID].componentsID.indexOf(this.slideContainerActive.id);
        }
      } else {
        return 0;
      }
    },
  },
};
</script>

<style lang="scss">
</style>